import React from 'react';
import { Button, Typography } from '@mui/material';
import { COLOR_PRIMARY_2, KPI_CARD_COLOR } from 'src/utils/colors';
import { handleDemoMarketOnClick } from '../../helper';

const DemoButton = ({ dummyMarket, isRenderedInOption }) => {

  return (
    <Typography
      variant="body1"
      onClick={() => handleDemoMarketOnClick(dummyMarket)}
      style={{
        display: 'flex',
        alignItems: 'center',
        color: COLOR_PRIMARY_2,
        fontWeight: 'bold',
        textTransform: 'capitalize',
        cursor: 'pointer',
        marginLeft: '2px',
        marginRight: '6px',
      }}
    >
      Demo Market
    </Typography>
  );
};

export default DemoButton;
